import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4af04dab = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _5d5b24e3 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _f7d2e1f4 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _7a177b50 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _3b5d0210 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _17eb2504 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _4ec8cdbc = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _02104797 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _58ba0640 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _154b9d81 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _14f434d6 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _812198ca = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _f520b0be = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _c578c010 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _7fc87070 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _788bd65b = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _48421afc = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _cfe0eb90 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _60554f23 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _61989e83 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _7e805a3c = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _b137908c = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _89bf7624 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _22884cbf = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _4cf43c76 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _71c7fc80 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _9aa0f67c = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _f8e9dd80 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _68252ec4 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _71d303ec = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _602f7441 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _6d1ab8ac = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _45d37e1d = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _568f9756 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _4f59fad7 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _4c125ea6 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _4c1c9588 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _38e82176 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _0accf388 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _33916130 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _0808fa68 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _23c593f4 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _986e536a = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _340c2142 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _3f7b0676 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _cb73ecde = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _412b6b3b = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _7e36d256 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _5d10a3c6 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _e460da12 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _eb958884 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _01f99686 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _4e2dc2ce = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _13495bea = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _c1ddb984 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _cfee6dba = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _ad902440 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _4daf2e02 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _ca479874 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _463237f1 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _83fc7656 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _25a738b0 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _bd173876 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _bffd7006 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _6b6259f0 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _2a08825a = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _a82eca24 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _0be3fe58 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _0fa2df60 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _5b8ab748 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _5f0a493d = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _03c78f11 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _5d76fba5 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _41e2a05a = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _ac9bdcf6 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _58db60c3 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _4af04dab,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _5d5b24e3,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _f7d2e1f4,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _7a177b50,
    name: "calendar"
  }, {
    path: "/customer",
    component: _3b5d0210,
    name: "customer"
  }, {
    path: "/details",
    component: _17eb2504,
    name: "details"
  }, {
    path: "/goals",
    component: _4ec8cdbc,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _02104797,
    name: "maisoku"
  }, {
    path: "/media",
    component: _58ba0640,
    name: "media"
  }, {
    path: "/privacy",
    component: _154b9d81,
    name: "privacy"
  }, {
    path: "/project",
    component: _14f434d6,
    name: "project"
  }, {
    path: "/response",
    component: _812198ca,
    name: "response"
  }, {
    path: "/sale",
    component: _f520b0be,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _c578c010,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _7fc87070,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _788bd65b,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _48421afc,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _cfe0eb90,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _60554f23,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _61989e83,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _7e805a3c,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _b137908c,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _89bf7624,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _22884cbf,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _4cf43c76,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _71c7fc80,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _9aa0f67c,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _f8e9dd80,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _68252ec4,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _71d303ec,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _602f7441,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _6d1ab8ac,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _45d37e1d,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _568f9756,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _4f59fad7,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _4c125ea6,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _4c1c9588,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _38e82176,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _0accf388,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _33916130,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _0808fa68,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _23c593f4,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _986e536a,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _340c2142,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _3f7b0676,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _cb73ecde,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _412b6b3b,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _7e36d256,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _5d10a3c6,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _e460da12,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _eb958884,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _01f99686,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _4e2dc2ce,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _13495bea,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _c1ddb984,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _cfee6dba,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _ad902440,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _4daf2e02,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _ca479874,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _463237f1,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _83fc7656,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _25a738b0,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _bd173876,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _bffd7006,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _6b6259f0,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _2a08825a,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _a82eca24,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _0be3fe58,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _0fa2df60,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _5b8ab748,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _5f0a493d,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _03c78f11,
    name: "property-property",
    children: [{
      path: "contact",
      component: _5d76fba5,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _41e2a05a,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _ac9bdcf6,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _58db60c3,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
